export default __webpack_public_path__ + "static/media/om.bc2ec362.jpg";